import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'planner-empty-state',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './planner-empty-state.component.html',
  styleUrl: './planner-empty-state.component.scss',
})
export class PlannerEmptyStateComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() descriptionSecondLine: string = '';
  @Input() callToActionText: string = '';
  @Output() callToActionClick = new EventEmitter();
}
